<template>
    <div class="card-research">
        <CardHeaderComponent :level="this.currentLevel" :name="this.name" :description="this.description" placeholderLevel="Unresearched"/>
        <div class="card-requirements-container">
            <CardRequirementsComponent :resources="nextLevelResourceRequeriments" :requeriments="this.requirementCollection" />
        </div>
        <div class="card-time-container">
            <ProgressBarComponent 
                :totalTime="nextLevelTimeToResearch" 
                :elapsedTime="currentElapsedTime" 
                :showProgressBar="isResearching"
                :callbackEvent="finishResearchEvent" 
                />
        </div>
        <div v-if="!canBeResearch && !isResearching" class="card-alert-container">
            <AlertComponent :variant="alertVariantConstant.ERROR_ALERT">You do not meet the requirements to research</AlertComponent>
        </div>
        <div v-if="!isResearching" class="card-button-container">
            <ButtonComponent 
                :text="getButtonText" 
                :type="buttonConstant.PRIMARY_TYPE_BUTTON" 
                :onClickEvent="research" 
                :disabled="!canBeResearch" />
        </div>
        <!-- <div class="card-bg-container">
            <svg width="auto" height="auto" viewBox="0 0 353 352" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.8">
                    <path
                        d="M176.5 176C176.5 152.887 171.935 130.001 163.065 108.648C154.195 87.2944 141.194 67.8923 124.804 51.5492C108.415 35.2061 88.9576 22.242 67.5436 13.3972C46.1296 4.55237 23.1783 0 0 0V105.6C9.27131 105.6 18.4518 107.421 27.0174 110.959C35.583 114.497 43.3659 119.682 49.9217 126.22C56.4775 132.757 61.6779 140.518 65.2259 149.059C68.7739 157.6 70.6 166.755 70.6 176H176.5Z"
                        fill="#F5F5F5" />
                    <path
                        d="M176.5 352C176.5 328.887 171.935 306.001 163.065 284.648C154.195 263.294 141.194 243.892 124.804 227.549C108.415 211.206 88.9576 198.242 67.5436 189.397C46.1296 180.552 23.1783 176 0 176V281.6C9.27131 281.6 18.4518 283.421 27.0174 286.959C35.583 290.497 43.3659 295.682 49.9217 302.22C56.4775 308.757 61.6779 316.518 65.2259 325.059C68.7739 333.6 70.6 342.755 70.6 352H176.5Z"
                        fill="#F5F5F5" />
                    <path
                        d="M353 176C353 152.887 348.435 130.001 339.565 108.648C330.695 87.2944 317.694 67.8923 301.304 51.5492C284.915 35.2061 265.458 22.242 244.044 13.3972C222.63 4.55237 199.678 0 176.5 0V105.6C185.771 105.6 194.952 107.421 203.517 110.959C212.083 114.497 219.866 119.682 226.422 126.22C232.978 132.757 238.178 140.518 241.726 149.059C245.274 157.6 247.1 166.755 247.1 176V352H353L353 176Z"
                        fill="#F5F5F5" />
                </g>
            </svg>
        </div> -->
    </div>
</template>

<style scoped>
.card-research {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: var(--border-radius-s);
    border: 1px solid var(--border-1);
    background: var(--background-1);
    overflow: hidden;
}

.card-requirements-container {
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    max-height: 300px;
}

.card-surface-title {
    display: flex;
    padding: 12px 16px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    background-color: var(--background-1);
}

.card-surface-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    height: min-content;
    overflow-y: auto;
    overflow-x: hidden;
}

.card-time-container {
    display: flex;
    padding: 0px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
}

.card-alert-container {
    display: flex;
    padding: 0px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}

.card-button-container {
    display: flex;
    flex-grow: 1;
    height: 100%;
    padding: 16px;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}

.card-bg-container {
    display: flex;
    flex-grow: 1;
    height: 100%;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}
</style>

<script>
import * as alertVariantConstant from '@/constants/alertVariantConstant';
import * as buttonConstant from '@/constants/buttonConstant';
import * as resourceConstant from '@/constants/resourceConstant';
import * as resourceStyleConstant from '@/constants/resourceStyleClassConstant';

import { hoverEffect } from '@/composables/hoverEffectComposable';

import { userPlanetDataStorage } from '@/storages/userPlanetDataStorage';
import { userLoginDataStorage } from '@/storages/userLoginDataStorage';

import AlertComponent from './core/AlertComponent.vue'
import ButtonComponent from './core/button/ButtonComponent.vue'
import CardHeaderComponent from './card/CardHeaderComponent.vue'
import CardRequirementsComponent from './card/CardRequirementsComponent.vue'
import ProgressBarComponent from './core/ProgressBarComponent.vue'

export default {
    name: 'ResearchCardComponent',
    components: {
        CardHeaderComponent,
        CardRequirementsComponent,
        ProgressBarComponent,
        ButtonComponent,
        AlertComponent
    },
    setup() {
        hoverEffect();

        const userPlanetDataStorageInstance = userPlanetDataStorage();
        const userLoginDataStorageInstance = userLoginDataStorage();

        return {
            alertVariantConstant, 
            buttonConstant,
            resourceConstant,
            resourceStyleConstant,
            userPlanetDataStorageInstance,
            userLoginDataStorageInstance
        };
    },
    props: {
        technologyTypeId: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        currentLevel: {
            type: [Number, null],
            default: null
        },
        isResearched: {
            type: Boolean,
            required: true
        },
        planetQueue: {
            type: [Object, null],
            default: null
        },
        requirementCollection: {
            type: Array,
            default: () => []
        },
        levelCollection: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            planetId: this.userLoginDataStorageInstance.getUserMainPlanetId()
        }
    },
    computed: {
        nextLevel() {
            return this.isResearched ? this.currentLevel + 1: 0;
        },
        syncPlanetQueue: {
            get() {
                return this.planetQueue
            },
            set(newValue) {
                this.$emit('update:planetQueue', newValue);
            }
        },
        isResearching() {
            return null !== this.syncPlanetQueue;
        },
        nextLevelResourceRequeriments() {
            const position = this.isResearched ? 1 : 0;
            const requerimentsData = this.levelCollection[position];

            const metal = this.getMetal(requerimentsData);
            const crystal = this.getCrystal(requerimentsData);
            const deuterium = this.getDeuterium(requerimentsData);
            const energyCapacity = this.getEnergyCapacity(requerimentsData);

            const userPlanetData = this.userPlanetDataStorageInstance.getPlanetById(this.planetId);

            return [
                {type: resourceConstant.METAL_RESOURCE, amount: metal, status: this.getResourceStatus(metal, userPlanetData.metal)},
                {type: resourceConstant.CRYSTAL_RESOURCE, amount: crystal, status: this.getResourceStatus(crystal, userPlanetData.crystal)},
                {type: resourceConstant.DEUTERIUM_RESOURCE, amount: deuterium, status: this.getResourceStatus(deuterium, userPlanetData.deuterium)},
                {type: resourceConstant.ENERGY_RESOURCE, amount: energyCapacity, status: this.getResourceStatus(energyCapacity, userPlanetData.energyProduction)}
            ];
        },
        nextLevelTimeToResearch() {
            if (undefined === this.syncPlanetQueue?.finishAt) {
                const position = this.isResearched ? 1 : 0;
                const requerimentsData = this.levelCollection[position];

                return requerimentsData?.secondsToResearch;
            }
            
            const createdAt = new Date(this.syncPlanetQueue?.createdAt);
            const finishAt = new Date(this.syncPlanetQueue?.finishAt);
            
            return Math.round((finishAt - createdAt) / 1000);
        },
        canBeResearch() {
            let canBeResearch = true;

            for (const resource of this.nextLevelResourceRequeriments) {
                if (resourceStyleConstant.NEGATIVE_RESOURCE_STYLE === resource.status) {
                    canBeResearch = false;
                    break;
                }
            }

            if (canBeResearch) {
                for (const requeriment of this.requirementCollection) {
                    if (false === requeriment.accomplish) {
                        canBeResearch = false;
                        break;
                    }
                }
            }

            return canBeResearch;
        },
        currentElapsedTime() {
            if (undefined === this.syncPlanetQueue?.finishAt) {
                return 0;
            }

            const createdAt = new Date(this.syncPlanetQueue?.createdAt);
            const now = new Date();
            
            return Math.round((now - createdAt) / 1000);
        },
        getButtonText() {
            return this.isResearched ? `Upgrade to level ${this.nextLevel}`: 'Research'
        }
    },
    methods: {
        getMetal(levelCollection) {
           return levelCollection?.metalResearchPrice ?? 0;
        },
        getCrystal(levelCollection) {
            return levelCollection?.crystalResearchPrice ?? 0;
        },
        getDeuterium(levelCollection) {
            return levelCollection?.deuteriumResearchPrice ?? 0;
        },
        getEnergyCapacity(levelCollection) {
            return levelCollection?.energyCapacityToResearch ?? 0;
        },
        getResourceStatus(amount,minusCompareAmount) {
            if (0 > amount || undefined !== minusCompareAmount && minusCompareAmount < amount) {
                return resourceStyleConstant.NEGATIVE_RESOURCE_STYLE;
            }
            
            return resourceStyleConstant.DEFAULT_RESOURCE_STYLE;
        },
        async research() {
            try {
                const response = await this.$axios.researchTechnology(this.planetId, this.technologyTypeId);
                console.log("Response data:", response.data);
                console.log("Response code:", response.status);
                console.log("Response headers:", response.headers);
                this.syncPlanetQueue = response.data;

                await this.$globalEvent.updateUserPlanetResourceView(this.planetId);
            } catch(error) {
                console.error("Error reserching technology: ", error);
            }
        },
        finishResearchEvent() {
            this.syncPlanetQueue = null;
        }
    }
}
</script>
    